import React from "react";

import * as classes from "./Footer.module.css";

export default function () {
  return (
    <div className={classes.Main}>
      <h1>Contact</h1>
      <div className={classes.Footer}>
        <div className={classes.Icons}>
          <a href="https://www.linkedin.com/in/kenny-lov" target="_blank">
            <i className="fa fa-linkedin-square"></i>
            <span>https://www.linkedin.com/in/kenny-lov</span>
          </a>
          <a href="mailto:lov.kenny.hq@gmail.com" target="_blank">
            <i style={{fontSize: 22}} className="fa fa-envelope"></i>
            <span>lov.kenny1996@gmail.com</span>
          </a>
          <a href="https://www.kennylov.com" target="_blank">
            <i style={{fontSize: 22}} className="fa fa-code"></i>
            <span>https://www.kennylov.com</span>
          </a>
        </div>
      </div>
    </div>
  );
}
